/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDiamondSquareFilled: {
  name: 'diamond-square-filled';
  data: string;
} = {
  name: 'diamond-square-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.48 2.295a1.897 1.897 0 0 0-.703.36c-.319.242-8.055 7.997-8.204 8.225-.264.402-.312.575-.312 1.12s.048.718.312 1.12c.154.234 7.937 8.031 8.233 8.247.124.091.331.212.46.268.211.093.284.104.734.104s.523-.011.734-.104a2.89 2.89 0 0 0 .46-.268c.296-.216 8.079-8.013 8.233-8.247.264-.402.312-.575.312-1.12 0-.45-.011-.523-.104-.734a2.89 2.89 0 0 0-.268-.46c-.216-.296-8.013-8.079-8.247-8.233-.358-.235-.585-.305-1.04-.319-.274-.009-.482.005-.6.041"/></svg>`
};
